mod.modules.define("QuickLinks", "BaseModule", function (fn) {

    fn.prototype.init = function (params) {

        this.base("init", params);

        //create tooltips for disabled report links
        this.el.find("[rel=tooltip]").tooltip({
            maxWidth: 275,
            onEnter: function (self, e) {

                //remove any existing tips before showing new tip
                $('body > .tooltip-wrapper').empty().remove();
            },
            manualClose: true
        });

        //custom handling to keep tooltip open until module or tip loses focus
        this.el.find('.module-content').on('mouseleave', function (e) {
            setTimeout(function () {
                var $wrapper = $('body > .tooltip-wrapper');

                if ($wrapper.length > 0 && !$wrapper.is(':hover')) {
                    $wrapper.empty().remove();
                }
            }, 50);
        });

        this.el.find('.module-content li a').on('mouseenter', function (e) {
            setTimeout(function () {
                var $wrapper = $('body > .tooltip-wrapper');

                if ($wrapper.length > 0 && !$wrapper.is(':hover')) {
                    $wrapper.empty().remove();
                }
            }, 50);
        });

        $('body').on('mouseleave', '.tooltip-wrapper', function (e) {
            setTimeout(function () {
                $('body > .tooltip-wrapper').empty().remove();
            }, 50);
        });
    };

});